const fontOptions = [
	{ value: 'Arial', label: 'Arial' },
	{ value: 'Helvetica', label: 'Helvetica' },
	{ value: 'Times New Roman', label: 'Times New Roman' },
	{ value: 'Georgia', label: 'Georgia' },
	{ value: 'Open Sans', label: 'Open Sans' },
	{ value: 'Roboto', label: 'Roboto' },
	{ value: 'Roboto Serif', label: 'Roboto Serif' },
	{ value: 'Roboto Condensed', label: 'Roboto Condensed' },
	{ value: 'Roboto Mono', label: 'Roboto Mono' },
	{ value: 'Lato', label: 'Lato' },
	{ value: 'Montserrat', label: 'Montserrat' },
	{
		value: 'Montserrat Alternates',
		label: 'Montserrat Alternates',
	},
	{ value: 'Raleway', label: 'Raleway' },
	{ value: 'Poppins', label: 'Poppins' },
	{ value: 'Roboto Slab', label: 'Roboto Slab' },
	{ value: 'Playfair Display', label: 'Playfair Display' },
	{ value: 'Playfair', label: 'Playfair' },
	{ value: 'Nunito Sans', label: 'Nunito Sans' },
	{ value: 'Noto Sans', label: 'Noto Sans' },
	{ value: 'Oswald', label: 'Oswald' },
	{ value: 'Ubuntu', label: 'Ubuntu' },
	{ value: 'Nunito', label: 'Nunito' },
	{ value: 'Rubik', label: 'Rubik' },
	{ value: 'Merriweather', label: 'Merriweather' },
	{ value: 'PT Sans', label: 'PT Sans' },
	{ value: 'Kanit', label: 'Kanit' },
	{ value: 'Mukta', label: 'Mukta' },
	{ value: 'Lora', label: 'Lora' },
	{ value: 'Marcellus', label: 'Marcellus' },
	{ value: 'Marcellus SC', label: 'Marcellus SC' },
	{ value: 'Work Sans', label: 'Work Sans' },
	{ value: 'Quicksand', label: 'Quicksand' },
	{ value: 'Barlow', label: 'Barlow' },
	{
		value: 'Barlow Semi Condensed',
		label: 'Barlow Semi Condensed',
	},
	{ value: 'Matangi', label: 'Matangi' },
	{ value: 'Huninn', label: 'Huninn' },
	{ value: 'Baloo 2', label: 'Baloo 2' },
	{ value: 'Heebo', label: 'Heebo' },
	{ value: 'DM Sans', label: 'DM Sans' },
	{ value: 'Mulish', label: 'Mulish' },
	{ value: 'IBM Plex Sans', label: 'IBM Plex Sans' },
	{ value: 'PT Serif', label: 'PT Serif' },
	{ value: 'Titillium Web', label: 'Titillium Web' },
	{ value: 'Libre Franklin', label: 'Libre Franklin' },
	{ value: 'Inter', label: 'Inter' },
	{ value: 'Manrope', label: 'Manrope' },
	{ value: 'Inconsolata', label: 'Inconsolata' },
	{ value: 'Nanum Gothic', label: 'Nanum Gothic' },
	{ value: 'Josefin Sans', label: 'Josefin Sans' },
	{ value: 'Karla', label: 'Karla' },
	{ value: 'Dosis', label: 'Dosis' },
	{ value: 'PT Sans Narrow', label: 'PT Sans Narrow' },
	{ value: 'PT Sans Caption', label: 'PT Sans Caption' },
	{ value: 'Space Grotesk', label: 'Space Grotesk' },
	{ value: 'Oxygen', label: 'Oxygen' },
	{ value: 'Bebas Neue', label: 'Bebas Neue' },
	{ value: 'Abel', label: 'Abel' },
	{ value: 'Assistant', label: 'Assistant' },
	{ value: 'Cabin', label: 'Cabin' },
	{ value: 'Bitter', label: 'Bitter' },
	{ value: 'Anton', label: 'Anton' },
	{ value: 'EB Garamond', label: 'EB Garamond' },
	{ value: 'Barlow Condensed', label: 'Barlow Condensed' },
	{ value: 'Jost', label: 'Jost' },
	{ value: 'Hind', label: 'Hind' },
    { value: 'Hind Mysuru', label: 'Hind Mysuru' },
    { value: 'Hind Guntur', label: 'Hind Guntur' },
    { value: 'Teko', label: 'Teko' },
	{ value: 'Source Code Pro', label: 'Source Code Pro' },
	{ value: 'Maven Pro', label: 'Maven Pro' },
	{ value: 'Prompt', label: 'Prompt' },
	{ value: 'Martel Sans', label: 'Martel Sans' },
	{ value: 'Crimson Text', label: 'Crimson Text' },
	{ value: 'Signika Negative', label: 'Signika Negative' },
	{ value: 'Fjalla One', label: 'Fjalla One' },
	{ value: 'Outfit', label: 'Outfit' },
	{ value: 'Rajdhani', label: 'Rajdhani' },
	{ value: 'Catamaran', label: 'Catamaran' },
	{ value: 'Comfortaa', label: 'Comfortaa' },
	{ value: 'Poiret One', label: 'Poiret One' },
	{ value: 'Exo', label: 'Exo' },
	{ value: 'Exo 2', label: 'Exo 2' },
	{ value: 'Signika', label: 'Signika' },
	{ value: 'Signika Negative', label: 'Signika Negative' },
	{ value: 'Patua One', label: 'Patua One' },
	{ value: 'Hammersmith One', label: 'Hammersmith One' },
	{ value: 'Alegreya Sans', label: 'Alegreya Sans' },
	{ value: 'Alegreya Sans SC', label: 'Alegreya Sans Sc' },
	{ value: 'Pacifico', label: 'Pacifico' },
	{ value: 'Orbitron', label: 'Orbitron' },
	{ value: 'Zilla Slab', label: 'Zilla Slab' },
	{ value: 'Great Vibes', label: 'Great Vibes' },
	{ value: 'Comic Neue', label: 'Comic Neue' },
	{ value: 'Bree Serif', label: 'Bree Serif' },
	{ value: 'Domine', label: 'Domine' },
	{ value: 'Cardo', label: 'Cardo' },
	{ value: 'Notable', label: 'Notable' },
	{ value: 'Varela Round', label: 'Varela Round' },
	{ value: 'Cutive Mono', label: 'Cutive Mono' },
	{ value: 'Darker Grotesque', label: 'Darker Grotesque' },
	{ value: 'Overpass', label: 'Overpass' },
	{ value: 'Overpass Mono', label: 'Overpass Mono' },
	{ value: 'Istok Web', label: 'Istok Web' },
	{ value: 'Asap', label: 'Asap' },
	{ value: 'Asap', label: 'Asap' },
	{ value: 'Fira Sans', label: 'Fira Sans' },
	{ value: 'Fira Sans Condensed', label: 'Fira Sans Condensed' },
	{
		value: 'Fira Sans Extra Condensed',
		label: 'Fira Sans Extra Condensed',
	},
	{ value: 'Archivo', label: 'Archivo' },
	{ value: 'Public Sans', label: 'Public Sans' },
	{ value: 'REM', label: 'REM' },
	{ value: 'Urbanist', label: 'Urbanist' },
	{ value: 'Chivo', label: 'Chivo' },
	{ value: 'Noto Sans Display', label: 'Noto Sans Display' },
	{ value: 'Noto Sans Adlam', label: 'Noto Sans Adlam' },
	{ value: 'Noto Sans Armenian', label: 'Noto Sans Armenian' },
	{ value: 'Noto Sans Avestan', label: 'Noto Sans Avestan' },
	{ value: 'Noto Sans Balinese', label: 'Noto Sans Balinese' },
	{ value: 'Noto Sans Bamum', label: 'Noto Sans Bamum' },
	{ value: 'Noto Sans Bassa Vah', label: 'Noto Sans Bassa Vah' },
	{ value: 'Noto Sans Batak', label: 'Noto Sans Batak' },
	{ value: 'Noto Sans Bengali', label: 'Noto Sans Bengali' },
	{ value: 'Noto Sans Brahmi', label: 'Noto Sans Brahmi' },
	{ value: 'Noto Sans Buginese', label: 'Noto Sans Buginese' },
	{ value: 'Noto Sans Buhid', label: 'Noto Sans Buhid' },
	{ value: 'Noto Sans Carian', label: 'Noto Sans Carian' },
	{ value: 'Noto Sans Cham', label: 'Noto Sans Cham' },
	{ value: 'Noto Sans Cherokee', label: 'Noto Sans Cherokee' },
	{ value: 'Noto Sans Coptic', label: 'Noto Sans Coptic' },
	{
		value: 'Noto Sans Chorasmian',
		label: 'Noto Sans Chorasmian',
	},
	{
		value: 'Noto Sans Canadian Aboriginal',
		label: 'Noto Sans Canadian Aboriginal',
	},
	{
		value: 'Noto Sans Anatolian Hieroglyphs',
		label: 'Noto Sans Anatolian Hieroglyphs',
	},
	{
		value: 'Noto Sans Adlam Unjoined',
		label: 'Noto Sans Adlam Unjoined',
	},
	{ value: 'Ysabeau Infant', label: 'Ysabeau Infant' },
	{ value: 'Ysabeau Office', label: 'Ysabeau Office' },
	{ value: 'Be Vietnam Pro', label: 'Be Vietnam Pro' },
	{ value: 'Saira', label: 'Saira' },
	{ value: 'Orienta', label: 'Orienta' },
	{ value: 'Rokkitt', label: 'Rokkitt' },
	{ value: 'Advent Pro', label: 'Advent Pro' },
	{ value: 'Inter Tight', label: 'Inter Tight' },
	{ value: 'Aleo', label: 'Aleo' },
	{ value: 'Petrona', label: 'Petrona' },
	{ value: 'Epilogue', label: 'Epilogue' },
	{ value: 'Taviraj', label: 'Taviraj' },
	{ value: 'Albert Sans', label: 'Albert Sans' },
	{ value: 'Fraunces', label: 'Fraunces' },
	{ value: 'Trirong', label: 'Trirong' },
	{ value: 'Noto Serif Display', label: 'Noto Serif Display' },
	{ value: 'Pathway Extreme', label: 'Pathway Extreme' },
	{ value: 'Hanken Grotesk', label: 'Hanken Grotesk' },
	{ value: 'Georama', label: 'Georama' },
	{ value: 'Sofia Sans', label: 'Sofia Sans' },
	{
		value: 'Sofia Sans Condensed',
		label: 'Sofia Sans Condensed',
	},
	{
		value: 'Sofia Sans Extra Condensed',
		label: 'Sofia Sans Extra Condensed',
	},
	{ value: 'Tomorrow', label: 'Tomorrow' },
	{ value: 'Chivo Mono', label: 'Chivo Mono' },
	{ value: 'Azeret Mono', label: 'Azeret Mono' },
	{ value: 'Gantari', label: 'Gantari' },
	{ value: 'Labrada', label: 'Labrada' },
	{ value: 'Piazzolla', label: 'Piazzolla' },
	{ value: 'Anybody', label: 'Anybody' },
	{ value: 'Texturina', label: 'Texturina' },
	{ value: 'Grenze', label: 'Grenze' },
	{ value: 'Niramit', label: 'Niramit' },
	{ value: 'Bai Jamjuree', label: 'Bai Jamjuree' },
	{ value: 'Krub', label: 'Krub' },
	{ value: 'Newsreader', label: 'Newsreader' },
	{ value: 'JetBrains Mono', label: 'JetBrains Mono' },
	{ value: 'Yrsa', label: 'Yrsa' },
	{ value: 'K2D', label: 'K2D' },
	{ value: 'Livvic', label: 'Livvic' },
	{ value: 'Pathway Extreme', label: 'Pathway Extreme' },
	{ value: 'Mali', label: 'Mali' },
	{ value: 'Wix Madefor Text', label: 'Wix Madefor Text' },
	{ value: 'Cormorant Infant', label: 'Cormorant Infant' },
	{ value: 'Proza Libre', label: 'Proza Libre' },
	{ value: 'Rasa', label: 'Rasa' },
	{ value: 'Bellefair', label: 'Bellefair' },
	{ value: 'Vollkorn', label: 'Vollkorn' },
	{ value: 'Cardo', label: 'Cardo' },
	{ value: 'Caladea', label: 'Caladea' },
	{ value: 'Mirza', label: 'Mirza' },
	{ value: 'Castoro', label: 'Castoro' },
	{ value: 'Caudex', label: 'Caudex' },
	{ value: 'Charis SIL', label: 'Charis SIL' },
	{ value: 'Cantata One', label: 'Cantata One' },
	{ value: 'Rosario', label: 'Rosario' },
	{ value: 'Fahkwang', label: 'Fahkwang' },
	{ value: 'KoHo', label: 'KoHo' },
	{ value: 'Schibsted Grotesk', label: 'Schibsted Grotesk' },
	{ value: 'Radio Canada', label: 'Radio Canada' },
	{ value: 'Kulim Park', label: 'Kulim Park' },
	{ value: 'Kantumruy Pro', label: 'Kantumruy Pro' },
	{ value: 'Kumbh Sans', label: 'Kumbh Sans' },
	{ value: 'Mitr', label: 'Mitr' },
	{ value: 'Molengo', label: 'Molengo' },
	{ value: 'Monda', label: 'Monda' },
	{ value: 'Moulpali', label: 'Moulpali' },
	{ value: 'Mukta Malar', label: 'Mukta Malar' },
	{ value: 'Mukta Vaani', label: 'Mukta Vaani' },
	{ value: 'Murecho', label: 'Murecho' },
	{ value: 'League Spartan', label: 'League Spartan' },
	{ value: 'Lekton', label: 'Lekton' },
	{ value: 'Slabo 27px', label: 'Slabo 27px' },
	{ value: 'Slabo 13px', label: 'Slabo 13px' },
	{ value: 'Lexend', label: 'Lexend' },
	{ value: 'Lexend Deca', label: 'Lexend Deca' },
	{ value: 'Lexend Zetta', label: 'Lexend Zetta' },
	{ value: 'Lexend Giga', label: 'Lexend Giga' },
	{ value: 'Lexend Mega', label: 'Lexend Mega' },
	{ value: 'Lexend Peta', label: 'Lexend Peta' },
	{ value: 'Lexend Exa', label: 'Lexend Exa' },
	{ value: 'Lexend Tera', label: 'Lexend Tera' },
	{ value: 'Mohave', label: 'Mohave' },
	{ value: 'Roboto Flex', label: 'Roboto' },
	{ value: 'Source Sans 3', label: 'Source Sans 3' },
	{ value: 'Figtree', label: 'Figtree' },
	{ value: 'Plus Jakarta Sans', label: 'Plus Jakarta Sans' },
	{ value: 'Sarabun', label: 'Sarabun' },
	{ value: 'Belanosima', label: 'Belanosima' },
	{ value: 'Belleza', label: 'Belleza' },
	{ value: 'Biryani', label: 'Biryani' },
	{ value: 'Cambay', label: 'Cambay' },
	{ value: 'Candal', label: 'Candal' },
	{ value: 'Cantarell', label: 'Cantarell' },
	{ value: 'Cantora One', label: 'Cantora One' },
	{ value: 'Capriola', label: 'Capriola' },
	{ value: 'Carlito', label: 'Carlito' },
	{ value: 'Carme', label: 'Carme' },
	{ value: 'Carrois Gothic', label: 'Carrois Gothic' },
	{ value: 'Carrois Gothic SC', label: 'Carrois Gothic SC' },
	{ value: 'Catamaran', label: 'Catamaran' },
	{ value: 'Chakra Petch', label: 'Chakra Petch' },
	{ value: 'Changa', label: 'Changa' },
	{ value: 'Chathura', label: 'Chathura' },
	{ value: 'Chau Philomene One', label: 'Chau Philomene One' },
	{ value: 'Comme', label: 'Comme' },
	{ value: 'Commissioner', label: 'Commissioner' },
	{ value: 'Convergence', label: 'Convergence' },
	{ value: 'Farro', label: 'Farro' },
	{ value: 'Federo', label: 'Federo' },
	{ value: 'M PLUS 1', label: 'M PLUS 1' },
	{ value: 'M PLUS 2', label: 'M PLUS 2' },
	{ value: 'M PLUS 1p', label: 'M PLUS 1p' },
	{ value: 'M PLUS 1 Code', label: 'M PLUS 1 Code' },
	{ value: 'M PLUS Rounded 1c', label: 'M PLUS Rounded 1c' },
	{ value: 'Magra', label: 'Magra' },
	{ value: 'Mada', label: 'Mada' },
	{ value: 'Mako', label: 'Mako' },
	{ value: 'Narnoor', label: 'Narnoor' },
	{ value: 'News Cycle', label: 'News Cycle' },
	{ value: 'Nobile', label: 'Nobile' },
	{ value: 'Nokora', label: 'Nokora' },
	{ value: 'Noto Music', label: 'Noto Music' },
	{ value: 'Mallanna', label: 'Mallanna' },
	{ value: 'Mandali', label: 'Mandali' },
	{ value: 'Manjari', label: 'Manjari' },
	{ value: 'Finlandica', label: 'Finlandica' },
	{ value: 'Jaldi', label: 'Jaldi' },
	{ value: 'Meera Inimai', label: 'Meera Inimai' },
	{ value: 'Metrophobic', label: 'Metrophobic' },
	{ value: 'Michroma', label: 'Michroma' },
	{ value: 'Mingzat', label: 'Mingzat' },
	{ value: 'Jockey One', label: 'Jockey One' },
	{ value: 'Jura', label: 'Jura' },
	{ value: 'Kosugi', label: 'Kosugi' },
	{ value: 'Kosugi Maru', label: 'Kosugi Maru' },
	{ value: 'Changa One', label: 'Changa One' },
	{ value: 'Chango', label: 'Chango' },
	{ value: 'Chela One', label: 'Chela One' },
	{ value: 'Cherry Cream Soda', label: 'Cherry Cream Soda' },
	{ value: 'Chicle', label: 'Chicle' },
	{ value: 'Chonburi', label: 'Chonburi' },
	{ value: 'Coda', label: 'Coda' },
	{ value: 'Concert One', label: 'Concert One' },
	{ value: 'LXGW Marker Gothic', label: 'LXGW Marker Gothic' },
	{ value: 'Expletus Sans', label: 'Expletus Sans' },
	{ value: 'Gugi', label: 'Gugi' },
	{ value: 'MuseoModerno', label: 'MuseoModerno' },
	{ value: 'Cousine', label: 'Cousine' },
	{ value: 'Martian Mono', label: 'Martian Mono' },
	{ value: 'Fira Mono', label: 'Fira Mono' },
	{ value: 'Savate', label: 'Savate' },
	{ value: ' Figtree ', label: ' Figtree ' },
	{ value: 'Bellota Text', label: 'Bellota Text' },
	{ value: 'Libre Barcode 128', label: 'Libre Barcode 128' },
	{
		value: 'Libre Barcode 128 Text',
		label: 'Libre Barcode 128 Text',
	},
	{ value: 'Libre Barcode 39', label: 'Libre Barcode 39' },
	{ value: 'Libre Barcode 39 Text', label: 'Libre Barcode 39 Text' },
	{
		value: 'Libre Barcode 39 Extended',
		label: 'Libre Barcode 39 Extended',
	},
	{
		value: 'Libre Barcode 39 Extended Text',
		label: 'Libre Barcode 39 Extended Text',
	},
	{
		value: 'Lilita One',
		label: 'Lilita One',
	},
];
export default fontOptions;